'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _actions = ['GET_INSTALLED_APPS', 'GET_INSTALLED_APPS_SUCCESS' // params: {apps:{map between appId and instanceId}}
];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(_actions);
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(_actions);